export default __webpack_public_path__ + "static/media/img_about_content-2.6a1c5858.png";